import firebase from "../firebase.js";
import spinner from "../spinner";
import displayListingEach from "../dispay-listings-each/display";
import displayBusinessEach from "../display-business-each/display";
import createListing from "../create-listing/create-listing.js";
import GENRALHELPERS from "../GENRAL-HELPERS.js";
import signUpProfile from "../sign-up_profile/signUpProfile.js";


const openHistory = false

class openUrls {
  #userData = {};

  _getGatheredUserData() {
    return this.#userData;
  }
  async _init() {

    console.error(openHistory, 'Open last is set to false for dev. Needs to be further developed and then turned on.')

    // GENRALHELPERS._clearUserHistory()
    console.log("init");

    const userSavedHistory = await GENRALHELPERS._getUserHistory()
    let useUrl = ''
    // console.warn(userSavedHistory.length);
    if (openHistory && userSavedHistory.length > 0) {
      useUrl = userSavedHistory[0].href
    }
    this._parseLocateAndDisplay(useUrl);
  }

  // Start visitStats
  async _storeUserVisitWithData(creditTo) {
    // Helper functions to collect the data
    function getDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
        return "Phone";
      } else if (/tablet|ipad/.test(userAgent)) {
        return "Tablet";
      }
      return "Desktop";
    }

    function getBrowser() {
      const userAgent = navigator.userAgent;
      if (/chrome|crios|crmo/i.test(userAgent)) {
        return "Chrome";
      } else if (/firefox|fxios/i.test(userAgent)) {
        return "Firefox";
      } else if (/safari/i.test(userAgent)) {
        return "Safari";
      } else if (/edge/i.test(userAgent)) {
        return "Edge";
      } else if (/opr|opera/i.test(userAgent)) {
        return "Opera";
      } else {
        return "Unknown";
      }
    }

    function getOperatingSystem() {
      const userAgent = navigator.userAgent;
      if (/windows/i.test(userAgent)) {
        return "Windows";
      } else if (/mac/i.test(userAgent)) {
        return "MacOS";
      } else if (/linux/i.test(userAgent)) {
        return "Linux";
      } else if (/android/i.test(userAgent)) {
        return "Android";
      } else if (/iphone|ipad|ipod/i.test(userAgent)) {
        return "iOS";
      } else {
        return "Unknown";
      }
    }

    function getScreenResolution() {
      return `${window.screen.width}x${window.screen.height}`;
    }

    function getLanguage() {
      return navigator.language || navigator.userLanguage || "null";
    }

    function getTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "null";
    }

    function isTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    let creditToObj = {
      creditTo: null,
    };

    if (creditTo) {
      creditToObj.creditTo = creditTo;
    }

    // Construct the user data object
    this.#userData = {
      device: getDeviceType() || "null", // Added deviceType for Phone, Tablet, Desktop, etc.
      browser: getBrowser() || "null",
      os: getOperatingSystem() || "null",
      screenResolution: getScreenResolution() || "null",
      language: getLanguage(),
      timeZone: getTimeZone(),
      isTouchDevice: isTouchDevice() || "null",
      userAgent: navigator.userAgent || "null",
      ip: "not tracked", // IP will be added later if needed
      ...creditToObj,
    };
    const result = await firebase._writeVisitStats(
      "siteVisits",
      this.#userData
    );
    console.log(result);

    return this.#userData;
  }
  // End visitStats

  _updateVisiteStats(creditTo) {
    this._storeUserVisitWithData(creditTo);
  }

  // https://mercadopromaq.netlify.app?creditTo=heramientashopelchen

  async _parseLocateAndDisplay(inUrl) {
    console.warn(inUrl)
    spinner._displaySpinner("Estamos cargando la información solicitada");
    let businessId;
    let listName;
    let listingId;
    let sellerId;
    let payment;

    // Function to parse URL and get business and listing IDs
    const parseUrlAndDisplay = () => {
      let url = window.location.href;
      if (inUrl) {
        url = inUrl;
      }

      if (url.includes("negocio") || url.includes("listado") || url.includes("subirlistado")) {
        url = url
      }

      // Check for payment
      if (url.includes("payment")) {
        const paymentToMatch = url.match(/payment=([^&?]+)/);
        if (paymentToMatch) {
          console.log(`Opened from stripe: ${paymentToMatch[1]}`);

          function waitForAccount() {
            const startTime = Date.now();

            const interval = setInterval(() => {
              const account = firebase._getLatestCurrentUserData();

              if (account) {
                clearInterval(interval);
                accountFound();
              } else if (Date.now() - startTime >= 10000) {
                clearInterval(interval);
                accountNotFound();
                console.warn("Timeout: No account found after 10 seconds.");
              }
            }, 500); // Check every 500ms
          }

          waitForAccount();
          const accountFound = () => {
            spinner._hideSpinner();
          };
          const accountNotFound = () => {
            alert(
              "No podimos encontrar tu cuenta en este momento. Puede ser por mala conexión a internet."
            );
            spinner._hideSpinner();
          };

          return;
        }
      }

      // Check for from email verified redirect
      if (url.includes("verified")) {

        signUpProfile._openEmailVerification(null, false)
        return
      }
      // Check for creditTo
      if (url.includes("creditTo")) {
        const creditToMatch = url.match(/creditTo=([^&?]+)/);
        if (creditToMatch) {
          console.log(`This visit is credited to: ${creditToMatch[1]}`);
          this._updateVisiteStats(creditToMatch[1]);
        } else {
          this._updateVisiteStats();
        }
      } else {
        this._updateVisiteStats();
      }

      // Extract 'negocio' id
      if (url.includes("negocio")) {
        const negocioMatch = url.match(/negocio=([^&?]+)/);
        if (negocioMatch) {
          businessId = negocioMatch[1]; // Set the businessId
        }
      }

      // Extract 'negocio' id, and list
      if (url.includes("lista")) {
        const listMatch = url.match(/lista=([^&?]+)/);
        if (listMatch) {
          listName = listMatch[1]; // Set the list 
        }
      }

      // Extract 'listado' id
      if (url.includes("listado")) {
        const listadoMatch = url.match(/listado=([^&?]+)/);
        if (listadoMatch) {
          listingId = listadoMatch[1]; // Set the listingId
        }
      }

      // Extract 'Seller' id
      if (url.includes("vendedor")) {
        const listadoMatch = url.match(/vendedor=([^&?]+)/);
        if (listadoMatch) {
          sellerId = listadoMatch[1]; // Set the listingId
        }
      }


      // Extract 'subirListado' id
      if (url.includes("subirlistado")) {
        createListing._init()
      }

      // Handle case where neither 'negocio' nor 'listado' are present
      if (!businessId && !listingId) {
        // console.log("No 'negocio' or 'listado' found in the URL.");
      }
    };

    // Run the function to parse the current URL
    parseUrlAndDisplay();

    // Log the IDs after parsing the URL

    let businessData;
    // Ensure businessId and listingId are set before trying to fetch data
    if (businessId) {
      businessData = await firebase._getBusinessById(businessId);
      displayBusinessEach._init(businessData, null, listName);
    }



    if (listingId && businessId) {
      console.log("business and listing present");
      const listingData = await firebase._getAnyDocById(
        `businesses/${businessId}/listings/${listingId}`
      );
      console.log(listingData);
      displayListingEach._init(listingData, businessData, true);
    }


    if (listingId && sellerId) {
      console.log("business and listing present");
      const listingData = await firebase._getAnyDocById(
        `accounts/${sellerId}/listings/${listingId}`
      );
      console.log(listingData);
      displayListingEach._init(listingData);
    }


    if (listingId && !businessId && !sellerId) {
      console.log("no business but listing present");
      const listingData = await firebase._getAnyDocById(
        `listings/${listingId}`
      );
      console.log(listingData);
      displayListingEach._init(listingData);
    }




    spinner._hideSpinner();
  }

  _getUserOpenedUrl() {
    const currentUrl = window.location.href; // Get the full URL
    return currentUrl;
  }
}

export default new openUrls();
